/*
 * -----------------------------------------------------------------------------------------
 * store.ts
 *
 * Copyright: (c) 2004-2020 Potthoff + Partner Unternehmensberatungs-Gesellschaft mbH
 *            All rights reserved.
 * -----------------------------------------------------------------------------------------
 * Erstellt : 13.10.2020
 * Autor    : Markus Plutka
 *
 * Geändert : 19.05.2022
 *      von : Jonas Wessel
 * -----------------------------------------------------------------------------------------
 *
 * Changelog:
 *
 */

import { initializeRequest } from "reducers/application";
import { createStore, applyMiddleware, compose, Middleware } from "redux";
import createSagaMiddleware from "redux-saga";
//import { sendUserLogObject } from "utils/log";
import { createActionLog } from "redux-action-log";
import rootReducer from "reducers/index";
import rootSaga from "sagas/root";

let store: any;
let actionLog;


export default async (callback) => {

    const sagaMiddleware = createSagaMiddleware({
        onError: (error: Error, errorInfo: {sagaStack: string}) => {

            const e = {
              error: error,
              stackTrace: errorInfo.sagaStack
            };

            console.error("Saga error", e);
        }
    });

    const middlewares: Middleware[] = [sagaMiddleware];

    const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    const enhancer = composeEnhancers(applyMiddleware(...middlewares));

    store = createStore(
        rootReducer,
        enhancer
    );

    sagaMiddleware.run(rootSaga(store));

    store.dispatch(initializeRequest());

    if (callback) {
        callback(store);
    }
};
export const storageMap = {};




const initSagaMiddleware = () => {

    const sagaMiddleware = createSagaMiddleware({
        onError: (error: Error, errorInfo: {sagaStack: string}) => {
            const auth = store.getState().authentication;
            const devReg = store.getState().deviceRegistration;
            let dev = "";
            if (auth && auth.deviceId) {
                dev = auth.deviceId;
            } else if (devReg && devReg.device && devReg.device.deviceId) {
                dev = devReg.device.deviceId;
            }

            const e = {
                error: error,
                stackTrace: errorInfo.sagaStack
            };

            console.error("Saga error", e);
            /*
            if (dev !== "") {
                sendSagaLog(dev, e, null, sendUserLogObject);
            }
            */
        }
    });

    const middlewares: Middleware[] = [sagaMiddleware];

    /*
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test") {
        const createLogger = require("redux-logger");

        const stateTransformer = (state: State) => omit(state, "patients", "syncData", "log");

        const logger = createLogger({
            level: "info",
            collapsed: true,
            stateTransformer
        });
        middlewares.push(logger);
    }
    */

    actionLog = createActionLog({ limit: 500 });
    const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    const enhancer = composeEnhancers(
        applyMiddleware(...middlewares),
        actionLog.enhancer
    );

    store = createStore(
        rootReducer,
        enhancer
    );

    sagaMiddleware.run(rootSaga(store));
};

export {
    initSagaMiddleware,
    actionLog,
    store
};


